import { Link } from "react-router-dom";

// lucide-react dropped brand/logo glyphs (trademark reasons) — no
// `Instagram` export exists in the installed version, so the glyph is
// inlined here instead of pulled from the icon library.
function InstagramGlyph({ size = 14 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

// Deliberately small and quiet — the bottom tab bar is the app's real
// primary navigation, this is just the conventional place legal links
// (and search crawlers) expect to find Privacy/Terms.
export default function Footer() {
  return (
    <footer className="mt-10 border-t border-mono/5 px-4 py-6 text-center text-xs text-ink-light">
      <p>&copy; {new Date().getFullYear()} Smart Connect Electrical. All rights reserved.</p>
      <p className="mt-2 flex items-center justify-center gap-3">
        <Link to="/privacy" className="hover:text-ink">Privacy Policy</Link>
        <span className="text-mono/20">·</span>
        <Link to="/terms" className="hover:text-ink">Terms of Service</Link>
      </p>
      <p className="mt-3 flex items-center justify-center gap-3">
        <a
          href="https://www.instagram.com/smartconnectleb"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 hover:text-gold-600 dark:hover:text-gold-400"
        >
          <InstagramGlyph size={14} />
          @smartconnectleb
        </a>
      </p>
      <p className="mt-2">
        <a
          href="https://www.instagram.com/jaafar.dev"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-ink-light/70 hover:text-gold-600 dark:hover:text-gold-400"
        >
          Built by Jaafar.Dev
          <InstagramGlyph size={12} />
        </a>
      </p>
    </footer>
  );
}
